// --- Contact forms ---

const contactWidget = document.querySelector('.contact-widget .wpcf7-form');

if(contactWidget) {
    let pageTitle = document.querySelector('h1');

    if(pageTitle.innerHTML) {
        contactWidget.querySelector('#contactPlaceholder').innerHTML = pageTitle.innerHTML;
    }
}